import { FormikHelpers } from "formik";
import { CreateFormValues, EditFormValues } from "./types";

interface ValuePair {
  label: string;
  value: string;
}

type FormValues = CreateFormValues & EditFormValues;
type SetFieldValue = Pick<
  FormikHelpers<FormValues>,
  "setFieldValue"
>["setFieldValue"];
type SetFieldTouched = Pick<
  FormikHelpers<FormValues>,
  "setFieldTouched"
>["setFieldTouched"];

/**
 * Return a value pair from a label
 */
export function valuePair(label: string): ValuePair {
  return { label, value: label };
}

/**
 * onChange handler for `<Select />` components within Formik.
 */
export function selectChange(
  key: keyof FormValues,
  setFieldValue: SetFieldValue
) {
  // TODO: React-select has some funky type definitions and because it's not a
  // dependency of insite (it's a peer of @bueno/blocks components) we can't assume
  // that it's available to import
  return (valPair: ValuePair | null | any) => {
    // NOTE: valPair will be `null` when the field is cleared using
    // react-selects `isClearable` prop
    const value = valPair !== null ? valPair.value : "";
    setFieldValue(key, value);
  };
}

/**
 * onBlur handler for `<Select />` components within Formik. This tells Formik
 * the field was touched, but to not validate immediately.
 */
export function selectBlur(
  key: keyof FormValues,
  setFieldTouched: SetFieldTouched
) {
  return () => {
    setFieldTouched(key, true, false);
  };
}

/**
 * A helper function to using the `window.history.back()` API
 */
export function handleGoBack() {
  window.history.back();
}
